 enum DataStructModuleId {
    
    // 工程头部
    projectHeader = 1,

    // 分辨率部分
    screenHash = 2, 

    //工程常量部分
    projectConstant = 4, 

    //系统设置部分
    systemData = 5,

    // 编辑器用游戏变量
    gameVar = 6,

    // 编辑器用到的游戏二周目变量
    gameVarEx = 7,

    //编辑器用字符串
    gameStr = 8,

    //编辑器用数组
    gameArray = 81,

    //编辑器用实例
    gameObj = 82,

    //编辑器用整合变量
    gameUnite = 9,

    // 用户的使用习惯记忆
    userRm = 10,

    // 整个剧情模块
    storyTree = 20,

    // 10000000 + map.id 单个剧情模块
    mapInfo = 10000000
}

export default DataStructModuleId